import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {stocksConst} from "../../../stocks/stocksConst";
import DLText from "dlcomponent/components/DLText/DLText";
import {isEmpty} from "../../../utils/validations";

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}
// TODO use lazy load for each component which is firing the api
function MarketCapCategoryView(props) {

    const {selectedStock, UIState, marketCapCategory, requiredIsin, stockName} = props;

    const renderMobileView = () =>{

        return (
            <div className=''>
                <div className="d-flex p-2" style={{minHeight:"40px", backgroundColor: ""}}>
                    <div className='' style={{flex:3}}>
                        <DLText marginBottom={'none'}
                                isInline={true}
                                text={!isEmpty(stockName)? stockName : ""}
                                onClick={() => {
                                    props.history.push("/stocks/" + requiredIsin)
                                }}
                                fontWeight={'semi-bold'}
                                isClickable={true}
                                fontColor={"#0073FF"}
                                fontSize={'xs'}/>
                    </div>
                    <div className='w-100' style={{flex:2}}>
                            <DLText
                                id={'revenue-value'}
                                type={'normal'}
                                text={marketCapCategory}
                                fontWeight={"semi-bold"}
                                fontSize={'sm'}/>
                    </div>
                </div>
            </div>
        )
    };

    const renderUI = () => {
            return renderMobileView();
    };

    if (UIState === stocksConst.CONTENT_UNAVAILABLE) {
        return
    }

    const activeStyle = {
        fontWeight: 500,
        color: '#282828',
        textDecoration: 'underline',
        fontFamily: 'Poppins, sans-serif',

    };
    props.handleChange();

    return (
        <>
            <div className="bg-white ">
                {/*<div className="text-end">    <i className="fa fa-remove m-2 cursor" onClick={() => {*/}
                {/*    clearOption(buttonIdReference)*/}
                {/*}} style={{color: appTheme.appColor.black}}/>*/}
                {/*</div>*/}

                <div id={'myDiv'}>
                    <div className=''>
                        {renderUI()}
                    </div>
                </div>
            </div>
        </>
    );
}

MarketCapCategoryView.propTypes = {};

export default MarketCapCategoryView;
